// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"05e81cd6","703":"9a51e41d"}[chunkId] + ".chunk.js";
};